import { useGetCurrentHealthcareProviderType } from './useGetCurrentHealthcareProviderType';

export const useResourceBranchByHealthcareProviderType = <ORGANIZATION_RESOURCE, PRACTICE_RESOURCE>(
   organizationResource: ORGANIZATION_RESOURCE,
   practiceResource: PRACTICE_RESOURCE
): ORGANIZATION_RESOURCE | PRACTICE_RESOURCE => {
   const healthcareProviderType = useGetCurrentHealthcareProviderType();
   return healthcareProviderType === 'HEALTHCARE_ORGANIZATION' ? organizationResource : practiceResource;
};
